import React from "react";
import { Text, Grid, GridItem, Image, Flex, Button, List, ListItem, UnorderedList} from "@chakra-ui/react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div id="about">
      <Grid
        templateAreas={{
          lg: `"header header"
                    "left right"`,
          base: `"header"
              "right"
              "left"`,
        }}
        gridTemplateRows={{ lg: "6rem 1fr", base: "5rem 1fr .2fr" }}
        gridTemplateColumns={{ lg: "1fr 3fr", base: "1fr" }}
        px={{md: "7rem", base: "3rem"}}
        overflow={"hidden"}
        py="5rem"
        bg={{ lg: "transparent", base: "offwhite" }}
        gap="2rem"
      >
        <GridItem area={"header"}>
          <Text variant={"subHeader"} textAlign="center" color="darkblue">
            About Me
          </Text>
        </GridItem>
        <GridItem
          area={"left"}
          display="flex"
          flexDir={{ lg: "column", base: "row" }}
          justifyContent={{ lg: "flex-start", base: "center" }}
          alignItems="center"
          height="100%"
          width="100%"
          gap="2rem"
        >
          <Image
            objectFit="contain"
            src={"/images/portrait3.jpg"}
            borderRadius={"1rem"}
            width={{ lg: "100%", base: "40%" }}
          />
          <Image
            objectFit="contain"
            src={"/images/portrait2.png"}
            borderRadius={"1rem"}
            width={{ lg: "100%", base: "40%" }}
          />
        </GridItem>
        <GridItem
          area={"right"}
          display="flex"
          alignItems={{ base: "center", md: "flex-start" }}
          flexDir={"column"}
          px={{lg: "2rem", base:"0rem"}}
        >
          <Text variant="type" color="darkgrey">
            Hi there! I'm Jess. I'm a software developer passionate about the <b>intersection of design and technology</b>
            —especially using computation to create thrilling visual effects. My
            interests span
            <b> front-end development, UX engineering, and computer graphics,</b>
            and I’m always eager to learn and experiment with new ways to bring
            interactive experiences to life.
          </Text>
          <br></br>
          <Text variant="tiniestHeader" color="darkblue">
            My Journey into CS
          </Text>
          <Text variant="type" color="darkgrey">
            I started my undergrad at Brown studying pre-medicine, but in my
            second year, I discovered my love for coding — especially building
            interactive visuals with JavaFX and creating 2D and 3D games. That
            passion led me to take numerous computer graphics courses, with the
            goal of {" "}
            <b>making my own 3D game on my custom game engine.</b> As a Masters student, I dove deeper into
            <b>3D animation and machine learning, </b>exploring how emerging
            technologies can enhance interactive experiences.
          </Text>
          <br></br>
          <Text variant="tiniestHeader" color="darkblue" align={"left"}>
            At Brown, I've...
          </Text>
          <br></br>
          <Text variant="type" color="darkgrey">
            <UnorderedList mx="4rem">
              <ListItem>
                <b>
                  Head TA’ed the largest UI/UX and front-end development course{" "}
                </b>
                in the CS department, leading a major curriculum redesign to
                reflect modern industry standards and better support aspiring
                product designers.
              </ListItem>
              <ListItem>
                <b>Co-founded a student club </b> centered around
                self-reflection, mindfulness, and cute stationery.
              </ListItem>
              <ListItem>
                <b>Hosted 12+ community-wide events</b> as a Resident Assistant,
                helping to foster connection among students.
              </ListItem>
            </UnorderedList>
          </Text>
          <br></br>
          <Text variant="tiniestHeader" color="darkblue">
            What I'm Exploring Now
          </Text>

          <Text variant="type" color="darkgrey">
            Outside of coding,
            I’m an avid artist, animator, and home chef (with a soft spot for
            Italian cuisine 🍝). I also love exploring nature and discovering
            new cafes.
          </Text>
           {/* <Link to="/animation">
                      <Button
                        variant="outline"
                        px="3rem"
                        color="lightblue"
                        borderColor="lightblue"
                        _hover={{ borderColor: "black", color: "black" }}
                        gap=".5rem"
                        mt="2rem"
                      >
                        Check out my 3D animated work!
                      </Button>
            </Link>
            <Link to="/art">
                      <Button
                        variant="outline"
                        px="3rem"
                        color="lightblue"
                        borderColor="lightblue"
                        _hover={{ borderColor: "black", color: "black" }}
                        gap=".5rem"
                        mt="1rem"
                      >
                        Check out my 2D Art!
                      </Button>
            </Link> */}
        </GridItem>
      </Grid>
    </div>
  );
}
